/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import {
  POST_SD_GET_EXTERNAL_USER_SETTINGS,
  POST_SD_SET_EXTERNAL_USER_SETTINGS,
  GET_CODETABLES_BY_TABLE_NAME,
  GET_SD_USER_EMAIL_LINKED_TO_OTHER_ACCOUNT_BY_EMAIL_ADDRESS,
  POST_SD_SEND_VERIFICATION_CODE,
  POST_SD_VERIFY_SUBMITTED_CODE,
} from './actionTypes';

/**
 * Updates the details in the 'SDYourSettings' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postSdGetExternalUserSettingsReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_SD_GET_EXTERNAL_USER_SETTINGS);

/**
 * Updates the indicator of creation of details in the 'SDYourSettings' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostSdGetExternalUserSettingsReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_SD_GET_EXTERNAL_USER_SETTINGS);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postSdGetExternalUserSettingsErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_SD_GET_EXTERNAL_USER_SETTINGS);

/**
 * Updates the details in the 'SDYourSettings' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postSdSetExternalUserSettingsReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_SD_SET_EXTERNAL_USER_SETTINGS);

/**
 * Updates the indicator of creation of details in the 'SDYourSettings' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostSdSetExternalUserSettingsReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_SD_SET_EXTERNAL_USER_SETTINGS);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postSdSetExternalUserSettingsErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_SD_SET_EXTERNAL_USER_SETTINGS);

/**
 * Updates the details in the 'SDYourSettings' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const getCodetablesByTableNameReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, GET_CODETABLES_BY_TABLE_NAME);

/**
 * Updates the indicator of creation of details in the 'SDYourSettings' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingGetCodetablesByTableNameReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, GET_CODETABLES_BY_TABLE_NAME);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const getCodetablesByTableNameErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, GET_CODETABLES_BY_TABLE_NAME);

/**
 * Updates the details in the 'SDYourSettings' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const getSdUserEmailLinkedToOtherAccountByEmailAddressReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(
    state,
    action,
    GET_SD_USER_EMAIL_LINKED_TO_OTHER_ACCOUNT_BY_EMAIL_ADDRESS
  );

/**
 * Updates the indicator of creation of details in the 'SDYourSettings' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingGetSdUserEmailLinkedToOtherAccountByEmailAddressReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(
    state,
    action,
    GET_SD_USER_EMAIL_LINKED_TO_OTHER_ACCOUNT_BY_EMAIL_ADDRESS
  );

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const getSdUserEmailLinkedToOtherAccountByEmailAddressErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(
    state,
    action,
    GET_SD_USER_EMAIL_LINKED_TO_OTHER_ACCOUNT_BY_EMAIL_ADDRESS
  );

/**
 * Updates the details in the 'SDYourSettings' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postSdSendVerificationCodeReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_SD_SEND_VERIFICATION_CODE);

/**
 * Updates the indicator of creation of details in the 'SDYourSettings' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostSdSendVerificationCodeReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_SD_SEND_VERIFICATION_CODE);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postSdSendVerificationCodeErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_SD_SEND_VERIFICATION_CODE);

/**
 * Updates the details in the 'SDYourSettings' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postSdVerifySubmittedCodeReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_SD_VERIFY_SUBMITTED_CODE);

/**
 * Updates the indicator of creation of details in the 'SDYourSettings' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostSdVerifySubmittedCodeReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_SD_VERIFY_SUBMITTED_CODE);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postSdVerifySubmittedCodeErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_SD_VERIFY_SUBMITTED_CODE);

const reducers = combineReducers({
  postSdGetExternalUserSettings: postSdGetExternalUserSettingsReducer,

  isFetchingPostSdGetExternalUserSettings: isFetchingPostSdGetExternalUserSettingsReducer,
  postSdGetExternalUserSettingsError: postSdGetExternalUserSettingsErrorReducer,

  postSdSetExternalUserSettings: postSdSetExternalUserSettingsReducer,

  isFetchingPostSdSetExternalUserSettings: isFetchingPostSdSetExternalUserSettingsReducer,
  postSdSetExternalUserSettingsError: postSdSetExternalUserSettingsErrorReducer,

  getCodetablesByTableName: getCodetablesByTableNameReducer,

  isFetchingGetCodetablesByTableName: isFetchingGetCodetablesByTableNameReducer,
  getCodetablesByTableNameError: getCodetablesByTableNameErrorReducer,

  getSdUserEmailLinkedToOtherAccountByEmailAddress:
    getSdUserEmailLinkedToOtherAccountByEmailAddressReducer,

  isFetchingGetSdUserEmailLinkedToOtherAccountByEmailAddress:
    isFetchingGetSdUserEmailLinkedToOtherAccountByEmailAddressReducer,
  getSdUserEmailLinkedToOtherAccountByEmailAddressError:
    getSdUserEmailLinkedToOtherAccountByEmailAddressErrorReducer,

  postSdSendVerificationCode: postSdSendVerificationCodeReducer,

  isFetchingPostSdSendVerificationCode: isFetchingPostSdSendVerificationCodeReducer,
  postSdSendVerificationCodeError: postSdSendVerificationCodeErrorReducer,

  postSdVerifySubmittedCode: postSdVerifySubmittedCodeReducer,

  isFetchingPostSdVerifySubmittedCode: isFetchingPostSdVerifySubmittedCodeReducer,
  postSdVerifySubmittedCodeError: postSdVerifySubmittedCodeErrorReducer,
});

export default { reducers };
